import React from "react";

import logo from "../assets/images/logo_p.png";

const PublicPage = ({ children }) => (
  <div className="background-reset">
    <div className="login">
      <div className="login-content">
        <div className="login_status">
          <div className="header text-center img-logo">
            <img src={logo} />
          </div>

          {children}
        </div>
      </div>
    </div>
  </div>
);

export default PublicPage;
